import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ImageUploader = ({ value, onChange, testid = "image-uploader", label = "Görsel" }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Lütfen bir resim dosyası seçin");
      return;
    }
    if (file.size > 8 * 1024 * 1024) {
      toast.error("Maksimum 8 MB");
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const fullUrl = data.url.startsWith("http")
        ? data.url
        : `${BACKEND_URL}${data.url}`;
      onChange(fullUrl);
      toast.success("Yüklendi");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Yükleme başarısız");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <div className="text-xs uppercase tracking-[0.2em] text-[#5C4D3C]">{label}</div>
      <div className="flex gap-3 items-start">
        {value ? (
          <img
            src={value}
            alt=""
            data-testid={`${testid}-preview`}
            className="w-24 h-24 object-cover rounded-sm border border-[#E2D9C8]"
          />
        ) : (
          <div className="w-24 h-24 bg-[#F4EFE6] border border-dashed border-[#E2D9C8] rounded-sm flex items-center justify-center text-[#5C4D3C]">
            <Upload size={18} />
          </div>
        )}
        <div className="flex-1 space-y-2">
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            onChange={handleFile}
            className="hidden"
            data-testid={`${testid}-input`}
          />
          <button
            type="button"
            data-testid={`${testid}-btn`}
            onClick={() => fileRef.current?.click()}
            disabled={uploading}
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] border border-[#B5441E] text-[#B5441E] px-4 py-2 rounded-sm hover:bg-[#B5441E]/5"
          >
            {uploading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
            {uploading ? "Yükleniyor..." : "Yükle"}
          </button>
          <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="veya URL yapıştırın"
            data-testid={`${testid}-url`}
            className="w-full text-xs px-3 py-2 bg-white border border-[#E2D9C8] rounded-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
